<template>
    <div>
        <div class="flex">            
            <app-table
                :columns="columns"
                :items="items"
                :loading="loading"
                :actions="actions"
                class="relative z-10 overflow-x-hidden"
            ></app-table>
            <app-table
                :columns="columns"
                :items="items"
                :loading="loading"
                :actions="actions"
                :clone="true"
                class="flex-none relative"
                style="width: 50px;"
                :width="50"
                position="right"
                v-if="!loading"
            ></app-table>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            items: {
                type: Array,
                default() {
                    return [];
                },
            },
            columns: {
                type: Array,
                required: true,
            },
            left: {
                type: Array,
                default() {
                    return [];
                }
            },
            right: {
                type: Array,
                default() {
                    return [];
                }
            },
            actions: {
                type: Array,
                default() {
                    return [];
                }
            },
            emptyMessage: {
                type: String,
                default: 'No items found.'
            },
            loading: {
                type: Boolean,
                defaul: false,
            }
        }
    }
</script>